import { createTheme } from '@mui/material';

export const colors = {
  'gray-1': '#bdbdbd',
  'gray-2': '#999',
  purplePrimary: '#9747FF',
  error: 'rgb(211, 47, 47)',
  black: '#000000',
  white: '#ffffff',
  lightGray: '#eeeeee',
  yellow: '#FFFF00',
  green: {
    100: '#d5f5e0',
    200: '#abebc1',
    300: '#81e2a3',
    400: '#57d884',
    500: '#2dce65',
    600: '#24a551',
    700: '#1b7c3d',
    800: '#125228',
    900: '#092914',
    1000: '#79c304',
    1100: '#00e676',
  },
  lightBlue: {
    100: '#d2eafb',
    200: '#a6d5f8',
    300: '#79c0f4',
    400: '#4dabf1',
    500: '#2096ed',
    600: '#1a78be',
    700: '#135a8e',
    800: '#0d3c5f',
    900: '#061e2f',
    1000: '#1a1c2f',
    1100: '#2196f3',
  },
  input: {
    100: '#d3d6da',
    200: '#a7aeb5',
    300: '#7b8591',
    400: '#4f5d6c',
    500: '#233447',
    600: '#1c2a39',
    700: '#151f2b',
    800: '#0e151c',
    900: '#070a0e',
  },
  darkBlue: {
    1000: '#282476',
  },
  background: {
    100: '#d2d2d5',
    200: '#a5a5ab',
    300: '#797780',
    400: '#4c4a56',
    500: '#1f1d2c',
    600: '#191723',
    700: '#13111a',
    800: '#0c0c12',
    900: '#060609',
  },
  purple: {
    100: '#7F43D0',
    200: '#5d2b86',
    300: '#52317E',
  },
  pink: {
    100: '#ed03fc',
  },
  red: {
    100: '#ff1744',
  },
};

let theme = createTheme();
const shadows = theme.shadows;
shadows[1] = `3px 3px ${colors.background[900]}`;

theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: colors.green[500],
    },
    background: {
      default: '#1f1d2c',
    },
  },
  shadows,
  typography: {
    fontFamily: `${['Montserrat'].join(' ')}, sans-serif !important`,
    fontWeightBold: 800,
    fontWeightLight: 200,
    fontWeightMedium: 500,
    fontWeightRegular: 400,
  },
});

export { theme };
